module.exports = __webpack_public_path__ + "img/verbatim-positif.fcceb18e.svg";